const reasons = [
  { icon: 'ri-shuffle-line', title: 'Обучают хаотично', desc: 'Тренинги проводятся от случая к случаю, без единой стратегии развития персонала и привязки к бизнес-целям.' },
  { icon: 'ri-organization-chart', title: 'Нет системы', desc: 'Компания проводит обучение, но нет связки: компетенции → программа → практика → оценка → развитие.' },
  { icon: 'ri-bar-chart-grouped-line', title: 'Нет оценки', desc: 'Никто не измеряет эффективность обучения. Непонятно, окупаются ли инвестиции в развитие.' },
  { icon: 'ri-tools-fill', title: 'Нет внедрения', desc: 'После тренинга сотрудники возвращаются к привычной работе. Инструменты не интегрированы в процессы.' },
  { icon: 'ri-folder-open-line', title: 'Нет базы знаний', desc: 'Материалы разбросаны по файлам, ссылкам и чатам. Нет единого источника знаний компании.' },
  { icon: 'ri-refresh-line', title: 'Нет повторения', desc: 'Одноразовое обучение не формирует навык. Без регулярного повторения знания забываются.' },
  { icon: 'ri-heart-pulse-line', title: 'Нет сопровождения', desc: 'После тренинга сотрудники предоставлены сами себе. Никто не помогает внедрять изменения.' },
  { icon: 'ri-user-voice-line', title: 'Нет внутренних наставников', desc: 'Обучение полностью зависит от внешних тренеров. Компания не развивает собственный тренерский состав.' },
];

const chain = [
  { icon: 'ri-close-circle-line', label: 'Хаотичное обучение', desc: 'Без системы и стандартов' },
  { icon: 'ri-arrow-down-line', label: '', desc: '', isArrow: true },
  { icon: 'ri-emotion-sad-line', label: 'Низкая эффективность', desc: 'Сотрудники не применяют знания' },
  { icon: 'ri-arrow-down-line', label: '', desc: '', isArrow: true },
  { icon: 'ri-money-dollar-circle-line', label: 'Потеря бюджета', desc: 'Инвестиции в обучение не окупаются' },
  { icon: 'ri-arrow-down-line', label: '', desc: '', isArrow: true },
  { icon: 'ri-user-unfollow-line', label: 'Текучесть и застой', desc: 'Бизнес не растёт, люди уходят' },
];

export default function WhyTrainingFails() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему большинство корпоративного обучения не работает
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Компании тратят бюджеты на обучение, но не получают результата. Проблема не в сотрудниках — проблема в отсутствии системы.
        </p>

        {/* 8 reasons */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {reasons.map((r, i) => (
            <div key={i} className="bg-red-50 border border-red-200 rounded-xl p-5">
              <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${r.icon} text-lg text-red-500`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-1 text-sm">{r.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        {/* Infographic chain */}
        <div className="max-w-3xl mx-auto bg-gray-50 rounded-2xl p-8 md:p-12 border border-gray-200">
          <h3 className="text-xl font-bold text-gray-900 text-center mb-2">К чему приводит отсутствие системы обучения</h3>
          <p className="text-gray-600 text-center mb-8 text-sm">Цепочка последствий хаотичного подхода к развитию персонала</p>

          <div className="flex flex-col items-center gap-3">
            {chain.map((item, i) => (
              <div key={i} className="flex flex-col items-center">
                {item.isArrow ? (
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center">
                    <i className={`${item.icon} text-teal-600`}></i>
                  </div>
                ) : (
                  <div className={`rounded-xl px-6 py-4 text-center min-w-[200px] ${i === 0 ? 'bg-red-100 text-red-800' : i === 2 ? 'bg-orange-100 text-orange-800' : i === 4 ? 'bg-amber-100 text-amber-800' : 'bg-red-200 text-red-900'}`}>
                    <div className={`font-bold text-sm`}>{item.label}</div>
                    <div className="text-xs opacity-70">{item.desc}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}